var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_735_2792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.50016 6.00016C8.50016 5.72402 8.27631 5.50016 8.00016 5.50016C7.72402 5.50016 7.50016 5.72402 7.50016 6.00016V7.50016H6.00016C5.72402 7.50016 5.50016 7.72402 5.50016 8.00016C5.50016 8.27631 5.72402 8.50016 6.00016 8.50016H7.50016V10.0002C7.50016 10.2763 7.72402 10.5002 8.00016 10.5002C8.27631 10.5002 8.50016 10.2763 8.50016 10.0002V8.50016H10.0002C10.2763 8.50016 10.5002 8.27631 10.5002 8.00016C10.5002 7.72402 10.2763 7.50016 10.0002 7.50016H8.50016V6.00016Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00016 0.833496C4.04212 0.833496 0.833496 4.04212 0.833496 8.00016C0.833496 11.9582 4.04212 15.1668 8.00016 15.1668C11.9582 15.1668 15.1668 11.9582 15.1668 8.00016C15.1668 4.04212 11.9582 0.833496 8.00016 0.833496ZM1.8335 8.00016C1.8335 4.59441 4.59441 1.8335 8.00016 1.8335C11.4059 1.8335 14.1668 4.59441 14.1668 8.00016C14.1668 11.4059 11.4059 14.1668 8.00016 14.1668C4.59441 14.1668 1.8335 11.4059 1.8335 8.00016Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_735_2792"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircle);
export default __webpack_public_path__ + "static/media/AddCircle.4c9cfa63391108ea6cb54389a8f5440e.svg";
export { ForwardRef as ReactComponent };